/* Match mobile card padding to the loaded photo; leave the product pixels untouched. */
(() => {
  'use strict';
  if (window.shkMobileMediaReady) return;
  window.shkMobileMediaReady = true;
  const mobile = window.matchMedia('(max-width: 640px)');
  const scope = 'body.template-collection [data-section-type="collection"], body.template-index [data-shk-mobile-cards]';
  const selector = '.AspectRatio img.ProductItem__Image';
  const seen = new WeakMap();
  const cache = new Map();
  const targetScale = 1.13; // Option D, approved by Raúl; Change Brings Azul is the framing reference.
  const rgb = values => `rgb(${values.join(',')})`;
  const median = values => values.sort((a, b) => a - b)[Math.floor(values.length / 2)];

  function analyse(img) {
    const canvas = document.createElement('canvas');
    const ratio = img.naturalWidth / img.naturalHeight;
    canvas.width = Math.max(8, Math.round(Math.min(128, 128 * ratio)));
    canvas.height = Math.max(8, Math.round(Math.min(128, 128 / ratio)));
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    if (!ctx) return null;
    // Transparent product images retain the same neutral card background.
    ctx.fillStyle = '#efefef';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    const w = canvas.width, h = canvas.height;
    const pixels = ctx.getImageData(0, 0, w, h).data;
    function edge(y) {
      return [0, 1, 2].map(channel => {
        const values = [];
        for (let x = 0; x < w; x++) values.push(pixels[(y * w + x) * 4 + channel]);
        return median(values);
      });
    }
    const top = edge(0), bottom = edge(h - 1);
    // Check the part lost to this zoom, plus a small safety margin.
    // Photos that already fill their frame keep their original scale.
    const rim = (1 - 1 / targetScale) / 2 + .008;
    const rimX = Math.ceil(w * rim), rimY = Math.ceil(h * rim);
    let emptyRim = true;
    for (let y = 0; y < h && emptyRim; y++) {
      for (let x = 0; x < w; x++) {
        if (x >= rimX && x < w - rimX && y >= rimY && y < h - rimY) continue;
        const i = (y * w + x) * 4;
        if ([0, 1, 2].some(c => Math.abs(pixels[i + c] - (top[c] + (bottom[c] - top[c]) * y / (h - 1))) > 12)) {
          emptyRim = false;
          break;
        }
      }
    }
    return { top: rgb(top), bottom: rgb(bottom), scale: emptyRim ? String(targetScale) : '1' };
  }

  function update(img) {
    if (!mobile.matches || !(img instanceof HTMLImageElement) || !img.matches(selector) || !img.closest(scope)) return;
    if (!img.complete || !img.naturalWidth) return;
    const src = img.currentSrc || img.src;
    if (!src || seen.get(img) === src) return;
    const frame = img.closest('.AspectRatio');
    const prefix = img.classList.contains('ProductItem__Image--alternate') ? '--shk-alt-' : '--shk-photo-';
    seen.set(img, src);
    // Reset when a swatch/source changes; never keep a previous photo's colours.
    frame.style.removeProperty(prefix + 'top');
    frame.style.removeProperty(prefix + 'bottom');
    frame.style.removeProperty(prefix + 'scale');
    try {
      const result = cache.get(src) || analyse(img);
      if (!result) return;
      if (cache.size >= 200) cache.delete(cache.keys().next().value);
      cache.set(src, result);
      frame.style.setProperty(prefix + 'top', result.top);
      frame.style.setProperty(prefix + 'bottom', result.bottom);
      frame.style.setProperty(prefix + 'scale', result.scale);
    } catch (_) {
      // A future cross-origin photo may be unreadable. Keep it intact at scale 1.
    }
  }

  function scan(root) {
    if (!mobile.matches) return;
    if (root instanceof HTMLImageElement) update(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(update);
  }
  function init() {
    document.addEventListener('load', event => update(event.target), true);
    scan(document);
    // Supports collection filtering/pagination and theme-editor section replacement.
    new MutationObserver(records => {
      for (const record of records) for (const node of record.addedNodes) {
        if (node.nodeType === 1) scan(node);
      }
    }).observe(document.body, { childList: true, subtree: true });
    mobile.addEventListener('change', () => { if (mobile.matches) scan(document); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

